'use strict';

/* created by you 2015
    使用方式：
    html:<trs-color-picker col-obj="item.titlecolor"></trs-color-picker>,
    css:位于oneImage.css中，
    js:所需参数：传入从json串中获得的titlecolor字段即可
*/
angular.module('util.colorPicker', [])
    . directive('trsColorPicker', ['$timeout', '$q', function($timeout, $q) {
        return {
            restrict: 'EA',
            scope: {
                colObj: '=',
                colStyle: '='
            },
            reaplace: false,
            template: '<input type="text"/>',
            link: function(scope, element, attrs) {
                var pickEl = angular.element(element[0].children[0]);
                loadSpectrum().then(() => {
                    pickEl.spectrum({
                        color: scope.colObj || '#000000',
                        showInput: true,
                        preferredFormat: 'name',
                        change: function(selectedCol) {
                            $timeout(() => {
                                scope.colObj = colorRGB2Hex(selectedCol._r, selectedCol._g, selectedCol._b);
                            });
                        }
                    });
                });

                /**
             * [loadSpectrum description] 加载spectrum组件
             * @return {[type]} [description]
             */
                function loadSpectrum() {
                    let deffer = $q.defer();
                    if (angular.isFunction(pickEl.pickEl)) {
                        deffer.resolve();
                    } else {
                        LazyLoad.css(['./lib/spectrum/spectrum.css'], function() {
                            LazyLoad.js([
                                './lib/bootstrap-colorpicker/bootstrap-colorpicker.js',
                                './lib/spectrum/spectrum.js',
                                './lib/tinycolor/tinycolor.js'
                            ], function() {
                                deffer.resolve();
                            });
                        });
                    }
                    return deffer.promise;
                }

                /**
             * [colorRGB2Hex description] rgb转16进制
             * @param  {[type]} r [description] 红
             * @param  {[type]} g [description] 绿
             * @param  {[type]} b [description] 蓝
             * @return {[type]}   [description]
             */
                function colorRGB2Hex(r, g, b) {
                    r = Math.round(r);
                    g = Math.round(g);
                    b = Math.round(b);
                    var hex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
                    hex = hex.split('.')[0];
                    return hex;
                }
            }
        };
    }]).directive('uiColorpicker', ['$timeout', '$parse', function ($timeout, $parse) {
        // 输出 rgba(196, 51, 25, 0.27)
        return {
            restrict: 'AE',
            replace: true,
            templateUrl: './components/util/uiColorpicker/colorpicker_tpl.html',
            scope: {
                uiColorpicker: '=', // 选取的颜色值
                immediatePreview: '=', // 是否实时切换颜色值
                disableAlpha: '=?' // 是否可调整透明度
            },
            link: function (scope, element, attrs) {
                var input = element.find('input');
                scope.colorValue = scope.uiColorpicker = scope.uiColorpicker || 'rgb(255, 255, 255)';
                scope.disableAlpha = scope.disableAlpha || false;

                function init() {
                    input.spectrum({
                        flat: false,
                        showInput: true,
                        showButtons: false,
                        showInitial: true,
                        showPalette: true,
                        clickoutFiresChange: true,
                        showAlpha: !scope.disableAlpha,
                        color: scope.uiColorpicker,
                        palette: [['#ffffff', '#000000', '#fbb3b3', '#ff0000', '#ff8000', '#ffff00', '#008000', '#00fffb', '#0000ff', '#4b0082', '#9400d3']],
                        preferredFormat: 'rgb',
                        containerClassName: 'ui-colorpicker-container', // 引用类选择器,可以改变颜色选择器面板的样式
                        replacerClassName: 'ui-colorpicker-replacer', // 引用类选择器,可以改变颜色选择器的样式
                        move: function (color) {
                            if (!scope.immediatePreview) {
                                return;
                            }
                            $timeout(function () {
                                scope.uiColorpicker = color.toRgbString();
                            }, 1);
                        },
                        hide: function (color) {
                            if (attrs.onclose) {
                                var fn = $parse(attrs.onclose);
                                fn(scope.$parent, {color: color});
                            }
                        }
                    });


                    scope.$watch('colorValue', function () {
                        if (scope.colorValue) {
                            scope.uiColorpicker = input.spectrum('get').toRgbString();
                        }
                    });

                    element.on('click', function () {
                        setTimeout(function () {
                            element.find('.sp-replacer').trigger('click');
                        }, 1);
                    });
                }

                $timeout(function () {
                    try {
                        init();
                    } catch (e) {
                        LazyLoad.css(['./lib/spectrum/spectrum.css'], function () {
                            LazyLoad.js([
                                './lib/spectrum/spectrum.js',
                            ], function () {
                                init();
                            });
                        });
                    }
                }, 0);
            }
        };
    }]);
